import { ISelectOptionsItem } from 'ui/components/v2/inputs/Select/types';
import { ActivityCategory } from 'ui/types/activities';
import { MeasurementUnit } from 'ui/types/measurementUnit';

import { IOffPlatformDefinitionFormFields } from '~/pages/Authenticated/OffPlatformApplication/components/DefinitionForm/types';
import { IOffPlatformLogFields } from '~/pages/Authenticated/OffPlatformApplication/components/LogForm/types';
import { CreateMeasurementOffPlatformDTO } from '~/types/dtos/measurement';

const measurementDate = new Date();

export const getInitialLogFields = (
  measurementUnits: MeasurementUnit[],
): IOffPlatformLogFields => {
  const measurements = measurementUnits.map((measurementUnit) => ({
    measurementUnit,
    amount: 0,
  }));

  return { measurements, measurementDate };
};

export const mapCauseOptions = (
  options?: Array<{ value?: string; label?: string }>,
): ISelectOptionsItem[] =>
  (options ?? []).map((opt) => ({
    value: opt.value ?? '',
    label: opt.label ?? '',
  }));

export const mapCauseOptionsToDto = (causes: ActivityCategory[]) =>
  causes.map((cause) => ({
    _id: cause._id ?? '',
    displayName: cause.displayName ?? '',
    relatedTo: cause.relatedTo ?? '',
    icon: cause.icon ?? '',
    images: cause.images ?? [],
    app: cause.app ?? '',
  }));

export const createMeasurementsDto = (
  measurements: IOffPlatformDefinitionFormFields['measurements'],
  measurementDate: Date,
  definitionData: any,
  causeOptions: ActivityCategory[],
): CreateMeasurementOffPlatformDTO[] =>
  measurements.map(({ amount, measurementUnit }) => ({
    ...definitionData,
    measurementUnitId: measurementUnit._id,
    measurementDate,
    amount,
    causeOptions: mapCauseOptionsToDto(causeOptions),
  }));

export const buildCauseOptions = (
  ids: string[],
  causeOptionsData: ActivityCategory[],
) => (causeOptionsData ?? []).filter((cause) => ids.includes(cause._id ?? ''));
